import React, { useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Footer from "../../components/Footer/Footer";
import useTranslate from "../../hooks/useTranslate";
import { textTransform } from "../../_helpers/textTransform";
import { allProjectsData } from "../../constants/data";
import "./CategoryProjects.scss";

// نقشه‌ای از slug کتگوری به مقدار link در data.js
const categoryLinkMap = {
  residential: "/residential",
  villa: "/villa",
  office: "/office",
  sport: "/sport",
  restaurant: "/restaurant",
  industrial: "/industrial",
  interior: "/interior",
  healthcare: "/healthcare",
  commercial: "/commercial",
  highrize: "/highrize",
  international: "/international",
};

// کلیدهای ترجمه عنوان کتگوری
const categoryTitleKeys = {
  residential: "category.residential",
  villa: "category.villa",
  office: "category.office",
  sport: "category.sport",
  restaurant: "category.restaurant",
  industrial: "category.industrial",
  interior: "category.interior",
  healthcare: "category.health",
  commercial: "category.commercial",
};

const CategoryProjects = () => {
  const { category } = useParams();
  const { translate, language } = useTranslate();
  const isFa = language === "fa";

  // فیلتر پروژه‌ها بر اساس کتگوری
  const filteredProjects = useMemo(() => {
    const linkValue = categoryLinkMap[category] || `/${category}`;
    if (!linkValue) return [];
    return allProjectsData.filter((project) => project.link === linkValue);
  }, [category]);

  // عنوان کتگوری
  const categoryTitle =
    translate(categoryTitleKeys[category]) ||
    textTransform(category, "capitalize");

  // تابع گرفتن تصویر کاور پروژه
  const getProjectCover = (project) => {
    // اگه src آرایه‌ست، اولین عکس رو بگیر
    if (Array.isArray(project.src)) {
      return project.src[0]?.src || project.src[0] || "";
    }
    // اگه src آبجکت با پراپرتی src هست
    if (project.src?.src) {
      return project.src.src;
    }
    // اگه خود src استرینگ هست
    if (typeof project.src === "string") {
      return project.src;
    }
    return "";
  };

  return (
    <>
      <Navbar />
      <div className={`category-projects  ${isFa ? "rtl-mode" : "ltr-mode"}`}>
        {/* بدون پروژه */}
        {filteredProjects.length === 0 && (
          <p className="category-projects__empty">
            {isFa ? "پروژه‌ای یافت نشد" : "No projects found"}
          </p>
        )}

        {/* گرید پروژه‌ها */}
        <div className="category-projects__grid">
          <Grid container spacing={0.5}>
            {filteredProjects.map((project) => (
              <Grid item xs={12} sm={6} md={6} key={project.id}>
                <Link
                  to={`/projects/${category}/${project.projectName}`}
                  className="project-card"
                >
                  <div className="project-card__wrapper">
                    <LazyLoadImage
                      effect="blur"
                      src={getProjectCover(project)}
                      alt={project.title}
                      className="project-card__image"
                    />
                    <div className="project-card__overlay">
                      <h2 className="project-card__name">
                        {isFa && project.titleFa
                          ? project.titleFa
                          : textTransform(project.title, "capitalize")}
                      </h2>
                    </div>
                  </div>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CategoryProjects;

